// MIT License - Copyright (c) 2026 Doug McNall

import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import './ContextualHint.css';

/**
 * Contextual Hint Component
 * Shows tutorial hints when relevant
 */
const ContextualHint = ({ hint, onDismiss }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Fade in after mount
    setTimeout(() => setVisible(true), 100);
  }, []);

  const handleDismiss = () => {
    setVisible(false);
    setTimeout(onDismiss, 300);
  };

  return createPortal(
    <div className={`contextual-hint-overlay ${visible ? 'visible' : ''}`}>
      <div className="contextual-hint">
        <div className="hint-icon">{hint.icon}</div>
        <div className="hint-content">
          <h3 className="hint-title">{hint.title}</h3>
          <p className="hint-message">{hint.message}</p>
        </div>
        <button className="hint-dismiss" onClick={handleDismiss}>
          Got it!
        </button>
      </div>
    </div>,
    document.body
  );
};

export default ContextualHint;
